<template>
  <div class="page-event">
    <Nav activeNav="home"></Nav>
    <Banner></Banner>
    <Video :detail="detail"></Video>
    <Process v-if="detail" :detail="detail"></Process>
    <News></News>
    <Works></Works>
    <Interview></Interview>
    <Contact></Contact>
  </div>
</template>

<script>
import Nav from './coms/nav'
import Banner from './coms/banner'
import Video from './coms/video'
import Process from './coms/process'
import News from './coms/news'
import Works from './coms/works'
import Interview from './coms/interview'
import Contact from './coms/contact'
import { parseQuery } from '@/utils/tools'

export default {
  data() {
    return {
      eventList: [],
      eventTotal: 0,
      eventCurrent: 1,
      eventPageSize: 10,
      loading: true,
      jsId: this.$route.params.jsId,
      detail: null
    }
  },
  components: {
    Nav,
    Banner,
    Video,
    Process,
    News,
    Works,
    Interview,
    Contact
  },
  async mounted() {
    if (!this.jsId) {
      this.jsId = await this.fetchList()
    }

    this.fetchDetail()
    this.fetchPopupConfig()
    this.recordVisit()
  },
  methods: {
    async fetchList(pageIndex = 1) {
      const [err, res] = await this.$serve.jsRecord.getPageList({
        data: { pageIndex }
      })
      if (err) return
      this.eventList = res.records
      this.eventTotal = res.total
      this.eventCurrent = res.pageIndex
      this.eventPageSize = res.pageSize
      return this.eventList[0].id
    },
    async fetchDetail() {
      this.loading = true
      const [err, res] = await this.$serve.jsRecord.info({
        queryId: this.jsId
      })
      this.loading = false
      if (err) return
      this.detail = res
    },
    async fetchPopupConfig() {
      this.loading = true
      const [err, res] = await this.$serve.jsTanchuang.infoByJs({
        queryId: this.jsId
      })
      this.loading = false
      if (err) return
      if (res && res.title) {
        this.$alert(
          `<p style="padding: 16px; line-height: 40px; min-height: 100px; text-align: center; font-size: 28px">${res.title}</p>`,
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false
          }
        )
      }
    },
    async recordVisit() {
      const { channel } = parseQuery()
      if (!channel) return
      this.$serve.jsBanner.recordVisit({
        data: {
          channel
        }
      })
    }
  }
}
</script>
